export class ExcelTemplate {
	public Processo: string
	public Identifier: string
	public ID_ÁRVORE: string
	public Protocolo: number
	public Requerente: string
	public Endereço: string
	public Referência_do_local: string
	public Protocolo_Avaliação: number | string
	public Agendamento: string
	public Avaliador: string
	public Status: string
	public Email_Requerente: string
	public Telefone_Requerente: string
	public CPF_Requerente: string
	public Tipo: string
	public Observações: string
	public Imagens: string
		public Problemas: string
	public Respostas_Arvore_Caída: string
}

export class ExcelTemplateOperator {
	public Protocolo_Avaliação: number
	public Risco_Avaliação: string
	public Data_Avaliação: string
	public Endereço: string
	public Protocolo_Manejo: number
	public Agendamento: string
	public Operador: string
	public Status: string
	public Numero_Árvore: string
	public Tipo: string
}

export class ExcelTemplateTree {
	public Árvore_id: string
	public Responsável: string
	public Conselho_de_classe_responsável: string
	public Data: Date
	public Duração_Avaliação: string
	public Endereço: string
	public Coordenadas_Geográficas: string
	public Árvore_Morta: string
	public Categoria_Local: string
	public Observações: string
	public Espécie: string
	public Nome_Popular: string
	public Família: string
	public Categoria_Especial: string
	public Origem: string
	public Altura_total: string
	public Altura_caule: string
	public Projeçao_copa: string
	public DAP: string
	public Volume_estimado_madeira: string
	public Valor_especial: string
	public Grau_Risco: string
	public Risco_Residual: string
	public Próxima_Avaliação: string
	public Solicitar_Avaliação_Aprofundada: string
	public Probabilidade_queda: string
	public Probabilidade_impacto: string
	public Consequência_queda: string
	public Recomendações_manejo: string
	public Considerações: string
	public Avaliação_Risco: string
	public Estado_Geral: string
	public Riscos_evidenciados: string
	public Respostas_avaliação: string
	public Tipo?: string
	public Foto_Principal: string
	public Fotos_Árvore: string
}


export class ExcelTemplateTreeInventaried {
	public Responsável: string
	public Email_do_responsável: string
	public Tempo_de_inventário: any
	public Cadastro: string
	public Processo: string
	public Identifier: string
	public ID_ÁRVORE: string
	public Data: string
	public Endereço: string
	public Estado_Geral: string
	public Espécie: string
	public Espécie_nome_popular: string
	public Manejo: string
	public Operação: string
	public OSA: string
	public OSO: string
	public Altura_total: string
	public Altura_caule: string
	public Projeçao_copa: string
	public Tipo_DAP_CAP: string
	public DAP_CAP: string
	public Formato_da_árvore: string
	public Valor_especial: string
	public Fotos_da_árvore: string
	public Conflitos_com_árvore: string
	public Status: string
	public Latitude: string
	public Fotos_conflitos_com_arvore: string
	public Fotos_estado_geral: string
	public Longitude: string
	public Observação: string

}
